/**
 * Reusable "spinner + label" loading row.
 */

import React from 'react';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';

import { OcppTheme } from './OcppTheme';

export interface OcppLoadingStateProps {
  label?: string;
  compact?: boolean;
}

const OcppLoadingState: React.FC<OcppLoadingStateProps> = ({
  label = 'Loading…',
  compact = false,
}) => {
  return (
    <View style={[styles.wrap, compact && styles.wrapCompact]}>
      <ActivityIndicator size={compact ? 'small' : 'large'} color={OcppTheme.accent} />
      <Text style={styles.label}>{label}</Text>
    </View>
  );
};

export default OcppLoadingState;

const styles = StyleSheet.create({
  wrap: {
    paddingVertical: 32,
    alignItems: 'center',
    justifyContent: 'center',
  },
  wrapCompact: {
    paddingVertical: 12,
    flexDirection: 'row',
  },
  label: {
    marginTop: 10,
    marginLeft: 10,
    color: OcppTheme.textMuted,
    fontSize: 13,
  },
});
